module.exports = __webpack_public_path__ + "img/60.97351e4d.jpg";